import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Suspense } from "react";

import router from "./router";
import { ModalProvider } from "./components/ui/ModalProvider";


ReactDOM.createRoot(document.getElementById("root")).render(
      <ModalProvider>
            <Suspense fallback={<div>Cargando...</div>}>
                  <RouterProvider router={router} />
            </Suspense>
      </ModalProvider>
);